import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.215, 0.61, 0.355, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", testid }) => (
  <motion.div
    data-testid={testid}
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, mode = "load", className = "" }) => {
  const outerRef = useRef(null);
  const inView = useInView(outerRef, { once: true, margin: "-60px" });
  return (
    <span ref={outerRef} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "110%" }}
        animate={mode === "load" ? { y: "0%" } : { y: inView ? "0%" : "110%" }}
        transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const SectionHeading = ({ eyebrow, title, sub, dark = false, className = "" }) => (
  <div className={className}>
    <Reveal>
      <p className={`eyebrow ${dark ? "text-terracotta" : "text-taupe"}`}>{eyebrow}</p>
    </Reveal>
    <MaskedLine mode="view">
      <h2
        className={`mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.1] tracking-tight ${
          dark ? "text-offwhite" : "text-espresso"
        } max-w-3xl`}
      >
        {title}
      </h2>
    </MaskedLine>
    {sub && (
      <Reveal delay={0.1}>
        <p
          className={`mt-5 max-w-xl text-sm sm:text-base font-light leading-relaxed ${
            dark ? "text-offwhite/70" : "text-charcoal/70"
          }`}
        >
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);
